import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";

@Component({
  selector: "app-addicon",
  templateUrl: "./addicon.component.html",
  styleUrls: ["./addicon.component.css"],
})
export class AddiconComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() type: string;
  @Input() description: string;
  @Input() title: string;
  @Input() class: string;
  @Input() data: string;
  @Input() disabled: boolean;
  @Output() callFunction = new EventEmitter();
  constructor() {}

  ngOnInit(): void {
    this.group = new FormGroup({
      firstName: new FormControl(),
    });
  }

  onClick(event) {
    this.callFunction.emit("I am button");
  }
}
